var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStampLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 76C55.8823 76 72 59.8823 72 40C72 20.1178 55.8823 4 36 4C16.1178 4 0 20.1178 0 40C0 59.8823 16.1178 76 36 76Z",
    fill: "#0E5CF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 71C59.33 71 75 55.33 75 36C75 16.67 59.33 1 40 1C20.67 1 5 16.67 5 36C5 55.33 20.67 71 40 71Z",
    fill: "white",
    stroke: "#00193C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.558 53.053C40.7381 53.9791 39.2794 53.9718 38.4717 53.0351C33.0802 46.7826 25.5785 38.4478 26.0185 29.4527C26.8098 21.4142 32.7697 15.1666 40.0043 15.1666C47.239 15.1666 53.1989 21.4142 53.9902 29.4527C54.296 39.3529 47.3987 46.4564 41.558 53.053Z",
    stroke: "#0E5CF4",
    strokeWidth: 2.33333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55.5H52",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47 29.1666C47 33.0326 43.866 36.1666 40 36.1666C36.134 36.1666 33 33.0326 33 29.1666C33 25.3006 36.134 22.1666 40 22.1666C43.866 22.1666 47 25.3006 47 29.1666Z",
    stroke: "#0E5CF4",
    strokeWidth: 2.33333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStampLocation);
export default __webpack_public_path__ + "static/media/ic-stamp-location.80fc0852c51dfa66da0dadbbc347978c.svg";
export { ForwardRef as ReactComponent };